// 3DS 認証からの戻り先（Issue #36）。
//
// サーバが Univapay に渡す `redirect_endpoint`（`modules/billing/univapay.py`）と同じパス。
// **ここでは権利を判定しない。** 認証を通っても課金の成立は Webhook が決めるので、
// この画面は状況を伝えてマイページへ送るだけにする。
import React from 'react';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function BillingCallbackPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        background:
          'radial-gradient(circle at 15% 0%, rgba(43,132,255,0.22), transparent 28%), linear-gradient(180deg, #02060d 0%, #07111d 46%, #03070f 100%)',
        color: '#eef8ff',
        fontFamily: '"Avenir Next", "Yu Gothic", "Hiragino Sans", sans-serif',
      }}
    >
      <Paper
        sx={{
          p: { xs: 3, sm: 5 },
          maxWidth: 560,
          borderRadius: 4,
          color: 'inherit',
          border: '1px solid rgba(92, 160, 219, 0.2)',
          background: 'linear-gradient(180deg, rgba(10,24,41,0.92), rgba(4,10,20,0.95))',
        }}
      >
        <Stack spacing={2}>
          <Typography
            sx={{ color: '#71dbff', fontSize: 12, letterSpacing: '0.24em', textTransform: 'uppercase' }}
          >
            Payment
          </Typography>
          <Typography sx={{ fontSize: { xs: 22, sm: 28 }, fontWeight: 700 }}>
            カード認証が完了しました
          </Typography>
          <Alert severity="info">
            決済の確認が取れ次第、ご利用いただけるようになります（通常は数分以内）。
            反映されない場合はマイページのご契約状態をご確認ください。
          </Alert>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            <Button
              component={RouterLink}
              to="/mypage"
              variant="contained"
              sx={{ borderRadius: 999, px: 3, textTransform: 'none', fontWeight: 700 }}
            >
              マイページで確認
            </Button>
            <Button
              component={RouterLink}
              to="/chiriri_model_race_list"
              sx={{ borderRadius: 999, textTransform: 'none', color: '#9ed7ff' }}
            >
              予想を見る
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}

export default BillingCallbackPage;
